// @components
import ModalWarning from "components/modal-warning";

// @styles
import './styles.scss'

export default function NotFound() {
    return (
        <div className='not-found'>
            <ModalWarning info={{ visible: true, type: 'notFound' }} />
        </div>
    )
}